import { flattenLatexPlain } from 'designSystem/readableMarkdown'
import {
  FadingGlyph,
  StreamingTextRoot,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/components/search/docChatStyles'
import React from 'react'

const graphemeClusters = (text: string): string[] =>
  Array.from(
    new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(text),
    (part) => part.segment
  )

export function FadingStreamText({
  text,
}: {
  text: string
}): React.ReactElement | null {
  if (!text) return null

  return (
    <StreamingTextRoot>
      {graphemeClusters(flattenLatexPlain(text)).map(
        (character, characterIndex) => (
          <FadingGlyph key={characterIndex}>{character}</FadingGlyph>
        )
      )}
    </StreamingTextRoot>
  )
}
